import { render } from "./Adminkonsole.vue?vue&type=template&id=e8aadf2a"
import script from "./Adminkonsole.vue?vue&type=script&lang=js"
export * from "./Adminkonsole.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__